import { Injectable } from '@angular/core';

import { tap, merge, Observable } from 'rxjs';

import { WebSocketEventsEnum } from '@shared/websocket';
import { LocationUser } from '@shared/user/models';
import {
  AccountApiService,
  LocationUsersQuery,
  LocationUsersStore,
  SocketService,
} from '@tablesready/frontend-store';

@Injectable({ providedIn: 'root' })
export class LocationUsersService {
  constructor(
    private readonly accountApiService: AccountApiService,
    private readonly query: LocationUsersQuery,
    private readonly store: LocationUsersStore,
    private readonly socketService: SocketService,
  ) {}

  load(): Observable<LocationUser[]> {
    return this.accountApiService.getLocationUsers()
      .pipe(
        tap(locationUsers => this.store.set(locationUsers)),
      );
  }

  selectAll(): Observable<LocationUser[]> {
    return this.query.selectAll();
  }

  getAll(): LocationUser[] {
    return this.query.getAll();
  }

  reset(): void {
    this.store.reset();
  }

  listenToChanges() {
    return merge(
      this.socketService
        .getEventStream<LocationUser[]>(WebSocketEventsEnum.locationUserCreated)
        .pipe(tap(locationUser => this.store.add(locationUser))),
      this.socketService
        .getEventStream<LocationUser[]>(WebSocketEventsEnum.locationUserUpdated)
        .pipe(tap(locationUsers => {
          for (let i = 0; i < locationUsers.length; i++) {
            this.store.update(locationUsers[i].id, locationUsers[i]);
          }
        })),
      this.socketService
        .getEventStream<string[]>(WebSocketEventsEnum.locationUserDeleted)
        .pipe(tap(ids => this.store.remove(ids))),
    );
  }
}
